import React, { useEffect } from "react";
import "./style/layout.scss";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import type { RootState } from "../../../store/store";
import Header from "../Header/header.tsx";
import Footer from "../Footer/footer.tsx";
import LoadingSpinner from "../../ui/Spinner/LoadingSpinner.tsx";
import { useVisitorData } from "../../../hooks/useVisitorData";
import { useStrings } from "../../../hooks/useStrings";

const Layout: React.FC = () => {
  const S = useStrings();
  const isLoading = useSelector((state: RootState) => state.app.isLoading);
  const { isPrefill } = useVisitorData();

  /*
    In Layout.tsx - check current route and hide footer accordingly
  */
  const location = useLocation();

  useEffect(() => {
    document.title = isPrefill
      ? S.PAGE_TITLES.PRE_ARRIVAL
      : S.PAGE_TITLES.DEFAULT;
  }, [isPrefill, location.pathname, S]);
  const routesWithoutFooter: string[] = [];
  const routesWithoutHeader = ["/", "/home"];

  const showFooter = !routesWithoutFooter.includes(location.pathname);
  const showHeader = !routesWithoutHeader.includes(location.pathname);

  return (
    <div className="layout-container">
      {showHeader && <Header />}
      <div className="layout-content">
        <div key={location.pathname} className="page-transition-fade">
          <Outlet />
        </div>
      </div>

      {showFooter && (
        <div className="layout-footer-bar">
          <Footer />
        </div>
      )}
      {isLoading && <LoadingSpinner overlay />}
    </div>
  );
};

export default Layout;
